import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";

const resetDeviceToken = async ({
  companyCode,
  employeeID,
  userName,
  currentUserRole,
}) => {
  let queryString = `?companyCode=${companyCode}&employeeID=${employeeID}&UserName=${userName}&currentUserRole=${currentUserRole}`;
  const { data } = await http_payroll.post(
    `${Api_EndPoints.ResetDevice}${queryString}`,
  );
  return data;
};

const changeLoginPermission = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.UpdateEmployeeLockStatus,
    input,
  );
  return data;
};

const updateEmpPassword = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.EmployeePasswordReset,
    input,
  );
  return data;
};

export const useResetDeviceMutation = () => {
  return useMutation({
    mutationFn: resetDeviceToken,
  });
};

export const useUpdateEmployeeLockStatusMutation = () => {
  return useMutation({
    mutationFn: changeLoginPermission,
  });
};

export const useUpdateEmployeePasswordMutation = () => {
  return useMutation({
    mutationFn: updateEmpPassword,
  });
};

const employeeLoginReport = async (input) => {
  console.log("input", input);
  try {
    const isAllCompanies = input?.isAllCompanies ?? false;
    let queryString = `${Api_EndPoints.GetEmployeeLogin}?CompanyCode=${input.companyCode}&LocationCode=${input.locationCode}`;

    if (isAllCompanies && input?.userId) {
      queryString += `&UserId=${input?.userId}&IsAllCompanies=${isAllCompanies}`;
    }
    const { data } = await http_payroll.get(queryString);

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const useEmployeeLoginReportQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetEmployeeLogin],
    queryFn: () => employeeLoginReport(input),
    refetchOnWindowFocus: false,
  });
};
